import { FormApi } from '@framework/ui/Organisms/FinalForm';
import FilterGroupItem from '@framework/ui/Organisms/Filters/components/FilterGroupItem';

export interface IFilterChildItem {
  value: string | number,
  label: string,
  disabled: boolean,
}

export interface IFilterGroupConfig<TKey extends string = string> {
  key: TKey,
  groupTitle: string,
  filterByChildrenName: string,
  nestedIds: string[],
  children: IFilterChildItem[],
  shouldRender?: boolean,
  filterByName?: string,
  withCounter?: boolean,
  isExpanded?: boolean,
}

interface IFilterGroupListProps<TFormValues, TKey extends string = string> {
  form: FormApi<TFormValues>,
  fieldComponent: React.ElementType,
  formValues: TFormValues,
  groups: IFilterGroupConfig<TKey>[],
  defaultFilterByName?: string,
  defaultWithCounter?: boolean,
  defaultIsExpanded?: boolean,
}

const FilterGroupList = <TFormValues, TKey extends string = string>({
  form,
  fieldComponent,
  formValues,
  groups,
  defaultFilterByName = 'includeAllType',
  defaultWithCounter = false,
  defaultIsExpanded = true,
}: IFilterGroupListProps<TFormValues, TKey>) => {
  return (
    <>
      { groups.map((group) => {
        if (group.shouldRender === false) {
          return null;
        }

        return (
          <FilterGroupItem
            key={ group.key }
            groupTitle={ group.groupTitle }
            form={ form }
            fieldComponent={ fieldComponent }
            formValues={ formValues }
            value={ group.key }
            filterByName={ group.filterByName || defaultFilterByName }
            filterByChildrenName={ group.filterByChildrenName }
            withCounter={ group.withCounter || defaultWithCounter }
            isExpanded={ group.isExpanded || defaultIsExpanded }
            nestedIds={ group.nestedIds }
          >
            { group.children }
          </FilterGroupItem>
        );
      }) }
    </>
  );
};

export default FilterGroupList;
